const WISHLIST_KEY = 'theme-wishlist';

function getWishlist() {
  const wishlist = localStorage.getItem(WISHLIST_KEY);
  return wishlist ? JSON.parse(wishlist) : [];
}

function saveWishlist(wishlist) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
}

function addToWishlist(handle) {
  const wishlist = getWishlist();
  if (!wishlist.includes(handle)) {
    wishlist.push(handle);
    saveWishlist(wishlist);
  }
}

function removeFromWishlist(handle) {
  let wishlist = getWishlist();
  wishlist = wishlist.filter(h => h !== handle);
  saveWishlist(wishlist);
}

function toggleWishlist(handle, buttonElement) {
  const wishlist = getWishlist();
  const isActive = wishlist.includes(handle);
  
  if (isActive) {
    removeFromWishlist(handle);
    buttonElement.classList.remove('is-active');
  } else {
    addToWishlist(handle);
    buttonElement.classList.add('is-active');
  }
  
  // Optionally, trigger a custom event if we want to update a badge count elsewhere
  document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist: getWishlist() } }));
}

function initWishlistButtons() {
  const wishlist = getWishlist();
  const buttons = document.querySelectorAll('.wishlist-button');
  
  buttons.forEach(button => {
    const handle = button.getAttribute('data-product-handle');
    if (!handle) return;
    
    // Set initial state
    if (wishlist.includes(handle)) {
      button.classList.add('is-active');
    } else {
      button.classList.remove('is-active');
    }
    
    // Clean up old listener if re-initializing
    button.removeEventListener('click', button.wishlistHandler);
    
    // Define handler
    button.wishlistHandler = (e) => {
      e.preventDefault(); // Prevent following link if button is inside a link
      e.stopPropagation(); // Prevent product card click
      toggleWishlist(handle, button);
    };
    
    button.addEventListener('click', button.wishlistHandler);
  });
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', initWishlistButtons);

// Expose globally to be re-initialized when products load dynamically (e.g. infinite scroll or filters)
window.initWishlistButtons = initWishlistButtons;
window.getWishlist = getWishlist;
window.removeFromWishlist = removeFromWishlist;
